/** Geometría SVG para radar de 5 ejes (EV, PC, OD, DC, GS). */

export type RadarPoint = { x: number; y: number };

/** Ángulo en grados: primer eje arriba (-90°), horarios. */
export function axisAngleDeg(index: number, count: number): number {
  return -90 + (360 / count) * index;
}

export function polarToCartesian(
  cx: number,
  cy: number,
  radius: number,
  angleDeg: number,
): RadarPoint {
  const rad = (angleDeg * Math.PI) / 180;
  return {
    x: cx + radius * Math.cos(rad),
    y: cy + radius * Math.sin(rad),
  };
}

/** Valor normalizado 0–1 → punto en eje. */
export function valueToPoint(
  cx: number,
  cy: number,
  maxRadius: number,
  index: number,
  count: number,
  value01: number,
): RadarPoint {
  const r = Math.max(0, Math.min(1, value01)) * maxRadius;
  return polarToCartesian(cx, cy, r, axisAngleDeg(index, count));
}

export function polygonPoints(points: RadarPoint[]): string {
  return points.map((p) => `${p.x.toFixed(2)},${p.y.toFixed(2)}`).join(' ');
}

/** Niveles 1–4 (o promedios) → polígono. */
export function radarPolygonFromLevels(
  levels: number[],
  cx: number,
  cy: number,
  maxRadius: number,
  maxLevel = 4,
): string {
  const count = levels.length;
  const pts = levels.map((lvl, i) =>
    valueToPoint(cx, cy, maxRadius, i, count, lvl / maxLevel),
  );
  return polygonPoints(pts);
}

export function ringPolygon(
  cx: number,
  cy: number,
  radius: number,
  count: number,
): string {
  const pts = Array.from({ length: count }, (_, i) =>
    polarToCartesian(cx, cy, radius, axisAngleDeg(i, count)),
  );
  return polygonPoints(pts);
}
